import React, { useContext, useMemo } from 'react';
import {
	type AiIssueBreakdownProps,
	AiIssueBreakdownEntryPointContext,
} from '@atlassian/jira-ai-work-breakdown';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';

export { IssueBreakdownPrompt } from './ui/issue-breakdown-prompt';
export { IssueBreakdownDraftList } from './ui/issue-breakdown-draft-list';
export { IssueBreakdownButton } from './ui/issue-breakdown-button';
export { IssueBreakdownError } from './ui/issue-breakdown-error';
export { AiIssueBreakdown } from './view';

export const AiIssueBreakdownEntryPointContainer = ({
	onCreate,
	childIssueTypes,
	isSubTaskCreationOpen,
	issueHierarchyLevel,
}: AiIssueBreakdownProps) => {
	const { entryPointReferenceSubject } = useContext(AiIssueBreakdownEntryPointContext);
	const runtimeProps = useMemo(
		() => ({ onCreate, childIssueTypes, isSubTaskCreationOpen, issueHierarchyLevel }),
		[onCreate, childIssueTypes, isSubTaskCreationOpen, issueHierarchyLevel],
	);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="jiraAIWorkBreakdownEntryPointContainer"
			packageName="jiraAIWorkBreakdown"
			teamName="crocs"
			fallback={null}
			runtimeProps={runtimeProps}
		/>
	);
};
